<nav class="breadcrumb-nav">
  <!-- Back button OUTSIDE the loop -->
  <!-- <button (click)="goBack()" class="back-btn">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="3">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>

  </button> -->

  <!-- Breadcrumbs -->
  <div class="breadcrumb-trail">
    @for (breadcrumb of breadcrumbService.breadcrumbs(); track breadcrumb.url) {
    <a [routerLink]="breadcrumb.url" [class.current-page]="$last">{{ breadcrumb.label }}</a>
    @if (!$last) {
    <span class="separator">/</span>
    }
    }
  </div>
</nav>